import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  RolePermissionsEditState,
  Signal,
} from "../../../../utils/interfaces/store/IStore";
import { ConfigReport } from "../../../../utils/types/ConfigReport";
import { IPayloadSetError } from "../../../Interfaces";

const initialState: RolePermissionsEditState = {
  configReports: Signal.default([]),
  saved: Signal.default([]),
  selected: [],
};

export const RolePermissionsEditSlice = createSlice({
  name: "RolePermissionsEdit",
  initialState,
  reducers: {
    clean: (_, action: PayloadAction<undefined>) => {
      return {
        ...initialState,
        action: { ...action } as any,
      } as RolePermissionsEditState;
    },
    setSelected: (state, action: PayloadAction<string>) => {
      const selected = [...state.selected];

      const index = selected.indexOf(action.payload);
      if (index !== -1) {
        selected.splice(index, 1);
      } else {
        selected.push(action.payload);
      }

      return {
        ...state,
        action: { ...action } as any,
        selected,
      } as RolePermissionsEditState;
    },
    getConfigReports: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.loading(),
      } as RolePermissionsEditState;
    },
    getConfigReportsSuccess: (state, action: PayloadAction<ConfigReport[]>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.success(action.payload),
      } as RolePermissionsEditState;
    },
    getConfigReportsError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
        configReports: Signal.error(
          action.payload.error,
          action.payload.shorterror
        ),
      } as RolePermissionsEditState;
    },
    getRolePermissionsSaved: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        saved: Signal.loading(),
      } as RolePermissionsEditState;
    },
    getRolePermissionsSavedSuccess: (
      state,
      action: PayloadAction<string[]>
    ) => {
      const newState = {
        ...state,
        action: { ...action } as any,
        saved: Signal.success(action.payload),
        selected: [...action.payload],
      } as RolePermissionsEditState;

      return newState;
    },
    getRolePermissionsSavedError: (
      state,
      action: PayloadAction<IPayloadSetError>
    ) => {
      return {
        ...state,
        action: { ...action } as any,
        saved: Signal.error(action.payload.error, action.payload.shorterror),
      } as RolePermissionsEditState;
    },
    save: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
      } as RolePermissionsEditState;
    },
    saveSuccess: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        action: { ...action } as any,
        saved: Signal.success([...state.saved.value!, action.payload]),
      } as RolePermissionsEditState;
    },
    saveError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
      } as RolePermissionsEditState;
    },
    delete: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
      } as RolePermissionsEditState;
    },
    deleteSuccess: (state, action: PayloadAction<string>) => {
      const saved = [...state.saved.value!];
      const index = saved.indexOf(action.payload);
      saved.splice(index!, 1);

      return {
        ...state,
        action: { ...action } as any,
        saved: Signal.success(saved),
      } as RolePermissionsEditState;
    },
    deleteError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
      } as RolePermissionsEditState;
    },
  },
});
